const ClearAppCache = () => {
    localStorage.clear();
}

export default ClearAppCache